import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex h-full flex-col gap-8 p-10 max-xl:p-6 max-md:px-3 max-md:py-8',
    header:
      'max-xs:flex-col flex gap-8 max-lg:flex-col max-lg:gap-6 max-sm:flex-row',
    left: 'flex grow flex-col gap-4',
    title: 'heading-3xl max-xs:heading-2xl',
    description: 'heading-m max-xs:heading-xs',
    cashback: 'shrink-0',
    cashbackPoints: 'heading-s-intr-bold tracking-[0.06em] uppercase',
    cashbackValue:
      'h-[85px] text-[96px] leading-none font-semibold tracking-[0.03em] uppercase',
    cashbackValuePercent: 'text-[64px]',
    privilegesContainer: 'grow',
    subTitle: 'heading-m-bold mb-4',
    privileges:
      'grid grid-cols-2 gap-x-12 gap-y-6 max-2xl:gap-x-5 max-lg:grid-cols-1 lg:gap-x-9',
    privilegesItem: 'flex gap-3 max-lg:items-center',
    privilegesItemIcon:
      'flex size-10 shrink-0 items-center justify-center rounded-full',
    icon: 'size-6 rounded-full',
    privilegesItemDescription: 'heading-s',
    steps: 'flex flex-col gap-3',
    step: 'flex gap-2',
    stepNumber: 'heading-s-bold',
    stepDescription: 'heading-s'
  },
  variants: {
    color: {
      primary: {
        base: 'bg-[#FAF4DC]',
        privilegesItemIcon: 'bg-[#FBEAA8]'
      },
      secondary: {
        base: 'bg-[#F9EAB0]',
        privilegesItemIcon: 'bg-white'
      }
    }
  },
  defaultVariants: {
    color: 'primary'
  }
});
